import { render } from "./InspectionMonitorMenu.vue?vue&type=template&id=9f5ab7f4"
import script from "./InspectionMonitorMenu.vue?vue&type=script&lang=js"
export * from "./InspectionMonitorMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__